import { Component, OnInit } from '@angular/core';
import { AuthService } from '../service/auth.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { BroadcastChannelService } from '../service/broadcast-channel.service';
import { ShowProgressEvent } from '../service/events';
import { EventService } from '../service/event.service';

@Component({
  selector: 'app-session-timed-out',
  templateUrl: './session-timed-out.component.html',
  styleUrls: ['./session-timed-out.component.scss'],
  standalone: false
})
export class SessionTimedOutComponent implements OnInit {

  login_registration: number = 1;
  login_aa: number = 2;
  login_dispute: number = 3;
  login_vendor: number = 4;

  loginType: number;
  verifyId: string;
  tokenId: string;
  nhpToken: string;

  private eventBus: EventService;

  constructor(private userService: AuthService, private router: Router, private dialog: MatDialog,
    private broadcastChannelService: BroadcastChannelService, eventBus: EventService
  ) {
    this.nhpToken = sessionStorage.getItem('nhpToken');
    this.eventBus = eventBus;
  }

  ngOnInit() {
    this.loginType = Number(localStorage.getItem('loginType'));
    this.verifyId = this.userService.getVerifyId();
    this.tokenId = this.userService.getAaToken();
    this.nhpToken = sessionStorage.getItem('nhpToken');

    this.broadcastChannelService.postMessage('logout');
    this.userService.invalidateTokenFamily().subscribe();
    
    sessionStorage.clear();
    localStorage.clear();

    if (this.nhpToken) {
      sessionStorage.setItem('nhpToken', this.nhpToken);
    }

    this.eventBus.emit(new ShowProgressEvent({ show: false }));

    this.dialog.closeAll();
  }

  initiationUrl() {
    if (this.login_registration == this.loginType) {
      this.router.navigate(['registration'], { queryParams: { verifyId: this.verifyId } });
    } else if (this.login_aa == this.loginType) {
      this.router.navigate(['viewAAGeneratedLetter'], { queryParams: { tokenId: this.tokenId } });
    } else if (this.login_dispute == this.loginType) {
      this.router.navigate(['disputeRegistration'], { queryParams: { verifyId: this.verifyId } });
    } else if (this.login_vendor == this.loginType) {
      this.router.navigate(['registrationVendor'], { queryParams: { verifyId: this.verifyId } });
    }
    else { //default registration
      this.router.navigate(['registration'], { queryParams: { verifyId: this.verifyId } });
    }
  }
}
